import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Refresh } from '@dbk/ui-icons';
import { PALETTE, KEY_CODE } from '../../../../constants';
import 'moment/min/locales';

class PaymentRefresh extends PureComponent {
  constructor(props) {
    super(props);
  }

  state = {
    refetching: false,
  }

  refetch = async (e) => {
    if ((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)) {
      if (this.state.refetching || this.props.payments.transactionListLoading) return;
      this.setState({ refetching: true })
      await this.props.payments.fetchPaymentList();
      setTimeout(() => {
        this.setState({ refetching: false })
      }, 100);
    }
  }

  render() {
    const {
      i18n: { messages },
    } = this.props;

    return (
      <div>
        <div className='payment-icon-group'>
          <div className="nav-icon-group">
            <span className="nav-icon-group-pass">
              <span className={'margin-left-20 pointer'} role="button" onKeyDown={(e) => this.refetch(e)} onClick={() => this.refetch()} tabIndex="0" aria-label={messages['app.payment.refreshButton']}>
                <Refresh id="refresh" color={PALETTE.secondaryActive} />
              </span>
            </span>
          </div>
        </div>

      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    payments: {
      getPaymentHistory: { $call: 'getPaymentHistory' },
      transactionListLoading: true,
      fetchPaymentList: { $call: 'fetchPaymentList'}
    },
  },
}
)(PaymentRefresh);
